import React, { useEffect, useState } from "react";
import "./Import.scss";

import { FaCheck } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import { FaMinusCircle } from "react-icons/fa";
import { GrCatalog } from "react-icons/gr";

import { useLocation, useNavigate } from "react-router-dom";
import InputSelect from "../../components/InputSelect/InputSelect";
import { customerFields, productFields } from "../../constants/csvFields";
import ROUTES from "../../constants/routes";
import CustomButton from "../../components/CustomButton/CustomButton";
import ToggleSwitch from "../../components/ToggleSwitch/ToggleSwitch";

import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { addBulkProducts } from "../../api/products";
import { addBulkCustomers } from "../../api/customers";
import { updateExistingProduct } from "../../redux/features/products-slice";
import { addNewCategory } from "../../redux/features/organization-slice";
import { processPhoneNumber } from "../../helpers/processPhoneNumber";
import { TfiReload } from "react-icons/tfi";
import { CountryCodes } from "../../constants/countryCodes";

const Import = ({ name }) => {
  const dispatch = useDispatch();
  const {
    id: organization_id,
    categories,
    countryCode,
  } = useSelector((state) => state.organizationReducer.value);

  const { id: branch_id } = useSelector((state) => state.branchReducer.value);

  const navigate = useNavigate();
  const location = useLocation();
  const [fields, setFields] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const [disableFirstRow, setDisableFirstRow] = useState(true);
  const [showInCatalog, setShowInCatalog] = useState(true);

  const [headers, setHeaders] = useState([]);

  const csvDataState = location.state?.csvData;

  const [finalData, setFinalData] = useState([]);

  const [csvData, setCsvData] = useState([]);

  const [uploadResult, setUploadResult] = useState({
    status: false,
    data: {
      successRate: 0,
      failedRate: 0,
    },
    failed_data_array: [],
  });

  const [failedData, setFailedData] = useState([]);

  const sellByOptions = [
    {
      label: "None",
      value: "none",
    },
    {
      label: "Unit",
      value: "Unit",
    },
    {
      label: "Kg",
      value: "Kg",
    },
    {
      label: "Inches",
      value: "Inches",
    },
  ];

  const [selectedSellBy, setSelectedSellBy] = useState(sellByOptions[0]);

  const decimalSelectorOptions = [
    {
      label: "Dot (.)",
      value: "dot",
    },
    {
      label: "Comma (,)",
      value: "comma",
    },
  ];

  const [selectedDecimalSelector, setSelectedDecimalSelector] = useState(
    decimalSelectorOptions[0]
  );

  const [selectedCodeOption, setSelectedCodeOption] = useState({
    label: "",
    value: "",
  });

  useEffect(() => {
    if (!(csvDataState?.length > 0)) {
      navigate(ROUTES.manageProduct.path);
    } else {
      setCsvData(csvDataState);
      let newOpts = csvDataState?.[0]?.map((header, i) => ({
        label: header || `Header_${i}`,
        value: i,
      }));

      newOpts?.unshift({
        label: "None",
        value: -1,
      });

      setHeaders(newOpts);
    }
  }, [csvDataState]);

  useEffect(() => {
    if (name === "customers") {
      setFields(customerFields);
    } else {
      setFields(productFields);
    }
  }, []);

  const handleOptionChange = (fieldKey, selectedValue) => {
    setFields((prevFields) =>
      prevFields.map((field) =>
        field.key === fieldKey ? { ...field, mappedTo: selectedValue } : field
      )
    );
  };

  const handleColumnMatch = () => {
    const invalidMappings = fields.filter(
      (field) => !field.mappedTo && field?.mappedTo !== 0
    );

    if (invalidMappings.length) {
      toast.dismiss(); toast.info("Please map all required fields!");
    } else {
      let new_data = [...csvData];

      if (disableFirstRow) {
        new_data.shift();
      }

      const new_array = [];

      new_data.forEach((row) => {
        let acc = {};
        fields.forEach((field) => {
          acc[field?.key] = field.mappedTo === -1 ? null : row[field.mappedTo];
        });

        if (name === "products") {
          acc["sell_by"] =
            selectedSellBy && selectedSellBy?.value !== "none"
              ? selectedSellBy?.value
              : null;

          if (typeof acc["price"] === "string") {
            let cleanedPrice = acc["price"];
            if (selectedDecimalSelector.value === "comma") {
              cleanedPrice = acc["price"].replace(/\./g, "").replace(/,/g, ".");
            } else {
              cleanedPrice = acc["price"].replace(/,/g, "");
            }
            if (/^\d+(\.\d+)?$/.test(cleanedPrice)) {
              acc["price"] = parseFloat(cleanedPrice);
            } else {
              acc["price"] = 0;
            }
          }

          if (typeof acc["reduced_price"] === "string") {
            let cleanedPrice = acc["reduced_price"];
            if (selectedDecimalSelector.value === "comma") {
              cleanedPrice = acc["reduced_price"]
                .replace(/\./g, "")
                .replace(/,/g, ".");
            } else {
              cleanedPrice = acc["reduced_price"].replace(/,/g, "");
            }
            if (/^\d+(\.\d+)?$/.test(cleanedPrice)) {
              acc["reduced_price"] = parseFloat(cleanedPrice);
            } else {
              acc["reduced_price"] = 0;
            }
          }

          acc["catalog"] = showInCatalog;
        }

        if (name === "customers") {
          acc["phone_number"] = processPhoneNumber(
            acc["phone_number"],
            selectedCodeOption?.value
          );
        }

        new_array.push(acc);
      });

      setFinalData(new_array);
    }
  };

  const handleSubmitData = () => {
    if (finalData?.length > 0) {
      setSubmitting(true);

      if (name === "customers") {
        const apiData = {
          organization_id: organization_id,
          branch_id: branch_id,
          customers: finalData,
        };

        addBulkCustomers(apiData)
          .then((res) => {
            const status = true;
            const successRate = res.data?.successfullyCreated?.length || 0;
            const failedRate = res.data?.failedToCreate?.length || 0;

            setUploadResult({
              status: status,
              data: {
                successRate: successRate,
                failedRate: failedRate,
              },
              failed_data_array: failedRate > 0 ? res.data?.failedToCreate : [],
            });
            setFinalData([]);
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              if (err?.response?.data?.message === "User not authorized!") {
                toast.dismiss(); toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
              } else {
                toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
              }
            } else {
              toast.dismiss(); toast.error("Error while uploading csv data.");
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        const apiData = {
          organization_id: organization_id,
          branch_id: branch_id,
          products: finalData,
        };

        addBulkProducts(apiData)
          .then((res) => {
            const status = true;
            const successRate = res.data?.successfullyCreated?.length || 0;
            const failedRate = res.data?.failedToCreate?.length || 0;

            if (successRate > 0) {
              dispatch(
                updateExistingProduct({
                  products: res.data?.successfullyCreated,
                })
              );

              const previous_categories = [...categories];

              res.data?.successfullyCreated?.forEach((el) => {
                el?.categories?.forEach((cat) => {
                  const exists = previous_categories?.find(
                    (c) => c?.id === cat?.id
                  );

                  if (!exists) {
                    previous_categories.push(cat);
                    dispatch(addNewCategory({ category: cat }));
                  }
                });
              });
            }

            setUploadResult({
              status: status,
              data: {
                successRate: successRate,
                failedRate: failedRate,
              },
              failed_data_array: failedRate > 0 ? res.data?.failedToCreate : [],
            });
            setFinalData([]);
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              if (err?.response?.data?.message === "User not authorized!") {
                toast.dismiss(); toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
              } else {
                toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
              }
            } else {
              toast.dismiss(); toast.error("Error while uploading csv data.");
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    } else {
      toast.dismiss(); toast.info("No data found.");
    }
  };

  return (
    <>
      <div className="desktop-navbar">
        <p>{name === "customers" ? "Import Customers" : "Import Products"}</p>
      </div>
      {uploadResult.status ? (
        <div className="csv-upload-result">
          <div className="inner-container">
            <div
              className={`svg ${
                uploadResult.data.successRate > 0 ? "success" : "danger"
              }`}
            >
              {uploadResult.data.successRate > 0 ? <FaCheck /> : <RxCross2 />}
            </div>
            <p
              className={`heading ${
                uploadResult.data.successRate > 0 ? "success" : "danger"
              }`}
            >
              Import {uploadResult.data.successRate > 0 ? "complete" : "failed"}
              !
            </p>
            <div className="result-details">
              {uploadResult.data.successRate > 0 && (
                <p>
                  <span className="bold">{uploadResult.data.successRate}</span>{" "}
                  {name} imported <span className="success">successfully.</span>
                </p>
              )}
              {uploadResult.data.failedRate > 0 && (
                <p>
                  <span className="bold">{uploadResult.data.failedRate}</span>{" "}
                  {name} import <span className="danger">failed!</span>{" "}
                  <span
                    className="view-failed-table"
                    onClick={() => {
                      setFailedData(uploadResult.failed_data_array);
                    }}
                  >
                    View Failed List
                  </span>
                </p>
              )}

              {!(uploadResult.data.successRate > 0) && (
                <p
                  className="retry"
                  onClick={() => {
                    setUploadResult({
                      status: false,
                      data: {
                        successRate: 0,
                        failedRate: 0,
                      },
                      failed_data_array: [],
                    });
                  }}
                >
                  Try Again
                </p>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="import-csv-file">
          <div className="container-wrapper import-csv-page">
            <p className="heading">
              Select fields from your CSV file to map against {name} fields, or
              to ignore during import.
            </p>

            <div className="map-list">
              {fields?.map((el, i) => {
                return (
                  <ColumnMap
                    key={i}
                    index={i}
                    item={el}
                    headers={headers}
                    handleOptionChange={handleOptionChange}
                    countryCode={countryCode}
                    selectedCodeOption={selectedCodeOption}
                    setSelectedCodeOption={setSelectedCodeOption}
                  />
                );
              })}
              {name === "products" && (
                <div className="column-map">
                  <p className="title">Field Name: Sell By</p>
                  <span></span>
                  <InputSelect
                    options={sellByOptions}
                    value={selectedSellBy}
                    register={() => {}}
                    required={false}
                    name={"sell_by"}
                    handleChange={(opt) => {
                      setSelectedSellBy(opt);
                    }}
                    reset={() => {}}
                    label={"Sell By"}
                    inputErrors={[]}
                  />
                </div>
              )}

              {name === "products" && (
                <div className="column-map">
                  <p className="title">Decimal Selector</p>
                  <span></span>
                  <InputSelect
                    options={decimalSelectorOptions}
                    value={selectedDecimalSelector}
                    register={() => {}}
                    required={false}
                    name={"decimal_selector"}
                    handleChange={(opt) => {
                      setSelectedDecimalSelector(opt);
                    }}
                    reset={() => {}}
                    label={"Decimal Selector"}
                    inputErrors={[]}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="bottom-buttons">
            {name === "products" && (
              <ToggleSwitch
                name={"show-in-catalog"}
                label={"Show Products In Catalog"}
                register={() => {}}
                SVG={GrCatalog}
                required={false}
                value={showInCatalog}
                handleChange={() => {
                  setShowInCatalog((pre) => !pre);
                }}
              />
            )}
            <ToggleSwitch
              name={"ignore-first-row"}
              label={"Ignore first row"}
              register={() => {}}
              SVG={FaMinusCircle}
              required={false}
              value={disableFirstRow}
              handleChange={() => {
                setDisableFirstRow((pre) => !pre);
              }}
            />
            <CustomButton
              name={"Import"}
              color={"primary"}
              type={"submit"}
              handleSubmit={handleColumnMatch}
              disabled={submitting}
              bigButton={true}
              loader={submitting}
            />
          </div>
        </div>
      )}

      <div
        className={`csv-preview-table ${finalData?.length > 0 ? "active" : ""}`}
      >
        <div>
          <table>
            <thead>
              <tr>
                <th>SN</th>
                {fields?.map((el, i) => {
                  return <th key={i}>{el?.label}</th>;
                })}
                {name === "products" && <th>Sell By</th>}
              </tr>
            </thead>
            <tbody>
              {finalData?.slice(0, 10)?.map((row, i) => {
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    {Object.values(row).map((value, j) => (
                      <td key={j}>{value}</td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="buttons">
            <CustomButton
              name={"Submit"}
              color={"primary"}
              type={"submit"}
              handleSubmit={handleSubmitData}
              disabled={submitting}
              bigButton={true}
              loader={submitting}
            />
          </div>
        </div>
        <p className="csv-note">
          <span>Note:</span> The table above displays the first 10 rows of data
          from your uploaded CSV file. Please review them before submitting.
        </p>
      </div>

      <div
        className={`csv-preview-failed-table ${
          failedData?.length > 0 ? "active" : ""
        }`}
      >
        <div>
          <table>
            <thead>
              <tr>
                <th>SN</th>
                {fields?.map((el, i) => {
                  return <th key={i}>{el?.label}</th>;
                })}
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              {failedData?.map((row, i) => {
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    {Object.values(row).map((value, j) => {
                      return (
                        <>
                          {j < fields?.length ? <td key={j}>{value}</td> : null}
                        </>
                      );
                    })}
                    <td>{`${
                      row?.error_message?.message
                        ? row?.error_message?.message
                        : row?.error_message
                    }`}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="buttons">
            <CustomButton
              name={"Close"}
              color={"danger"}
              type={"button"}
              handleSubmit={() => {
                setFailedData([]);
              }}
              disabled={false}
              bigButton={true}
            />
          </div>
        </div>
        <p className="csv-note">
          <span>Note:</span> The table above displays the rows of data from your
          uploaded CSV file that were{" "}
          <span className="danger">failed to upload.</span> Please review them
          and upload them in correct format.
        </p>
      </div>

      {(finalData?.length > 0 || failedData?.length > 0) && (
        <div
          className="back-blur-csv-preview"
          onClick={() => {
            setFinalData([]);
            setFailedData([]);
          }}
        ></div>
      )}

      <DonotCloseModel open={submitting} />
    </>
  );
};

export default Import;

const ColumnMap = ({
  item,
  headers,
  handleOptionChange,
  index,
  countryCode,
  selectedCodeOption,
  setSelectedCodeOption,
}) => {
  const [options, setOptions] = useState(headers);
  const [selectedOption, setSelectedOption] = useState({
    label: "",
    value: "",
  });

  const [codeOptions, setCodeOptions] = useState([]);

  useEffect(() => {
    const selectOptions = [];
    CountryCodes.forEach((item) => {
      selectOptions.push({
        label: `${item.flag}(${item.country_code})`,
        value: item.country_code,
      });
    });

    const orgDefault = selectOptions.find((el) => el?.value === countryCode);

    setSelectedCodeOption(orgDefault || selectOptions[0]);
    setCodeOptions(selectOptions);
  }, [countryCode]);

  useEffect(() => {
    setOptions(headers);
    if (headers?.length > 0) {
      const hasSimilar = headers?.find(
        (el) => `${el?.label}`.toLowerCase() === `${item?.label}`.toLowerCase()
      );
      hasSimilar
        ? setSelectedOption(hasSimilar)
        : setSelectedOption(headers[index] || headers[0]);
    }
  }, [headers]);

  useEffect(() => {
    if (selectedOption?.value || selectedOption?.value === 0) {
      handleOptionChange(item?.key, selectedOption?.value);
    }
  }, [selectedOption]);
  return (
    <div className="column-map">
      <p className="title">Field Name: {item?.label}</p>
      <span>
        {item?.example && "Sample:"} {item?.example}
      </span>
      {item?.key === "phone_number" ? (
        <div className="select-and-input">
          <InputSelect
            options={options}
            value={selectedOption}
            register={() => {}}
            required={false}
            name={item?.key || "select_name"}
            handleChange={(opt) => {
              setSelectedOption(opt);
            }}
            reset={() => {}}
            label={"Map with column"}
            inputErrors={[]}
          />

          <div className="select-wrapper">
            <InputSelect
              options={codeOptions}
              value={selectedCodeOption}
              register={() => {}}
              required={false}
              name="customer_country_code"
              handleChange={(opt) => {
                setSelectedCodeOption(opt);
              }}
              reset={() => {}}
              label={""}
              inputErrors={[]}
            />
          </div>
        </div>
      ) : (
        <InputSelect
          options={options}
          value={selectedOption}
          register={() => {}}
          required={false}
          name={item?.key || "select_name"}
          handleChange={(opt) => {
            setSelectedOption(opt);
          }}
          reset={() => {}}
          label={"Map with column"}
          inputErrors={[]}
        />
      )}
    </div>
  );
};

const DonotCloseModel = ({ open }) => {
  return (
    <div className={`donot-close-model ${open ? "active" : ""}`}>
      <TfiReload />
      <p>Please do not close this tab until importing is completed!</p>
    </div>
  );
};
